import pixelWidth from 'string-pixel-width';

export const getTextWidth = (value: string): number => {
  // We are using 14px, but the calculation is off.
  // Increase it to 16px to get more space.
  return pixelWidth(value, { size: 16 });
};
